"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * ProductSizesDTOConverter
 *
 * @author RV
 */


var ProductSizesDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ProductSizesDTOConverter, _DataObjectConverter_);

  function ProductSizesDTOConverter() {
    _classCallCheck(this, ProductSizesDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductSizesDTOConverter).apply(this, arguments));
  }

  return ProductSizesDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ProductSizesDTOConverter = ProductSizesDTOConverter;